import { ILegalService } from "../ILegalService";
import { TermsAndConditions, PrivacyPolicy, User } from "../../types";

export class LegalMockService implements ILegalService {
  async getLatestTerms(): Promise<TermsAndConditions> {
    const response = await fetch("/mocks/legal/terms-and-conditions.json");
    return response.json();
  }

  async getLatestPrivacy(): Promise<PrivacyPolicy> {
    const response = await fetch("/mocks/legal/privacy-policy.json");
    return response.json();
  }

  async acceptTerms(userId: string, version: string): Promise<void> {
    // No-op for mock
    return;
  }

  async acceptPrivacy(userId: string, version: string): Promise<void> {
    // No-op for mock
    return;
  }

  async checkUserAcceptance(user: User): Promise<{ termsAccepted: boolean; privacyAccepted: boolean }> {
    // Always return accepted for mock
    return { termsAccepted: true, privacyAccepted: true };
  }
}
